import { schema } from 'normalizr';

export const collectionsSchema = new schema.Entity('collections', {}, { idAttribute: 'id' });
